import BaseModel from "./BaseModel";

export class User extends BaseModel {
  /* eslint-disable-next-line */
  constructor(props) {
    super(props);
  }

  get isKurly() {
    return (
      this.username === "team@chainlogis.com" ||
      this.username === "johnj@chainlogis.co.kr" ||
      this.username === "kimjinsoo1129@naver.com" ||
      this.username === "kjaein77@fsdcorp.kr" ||
      this.username === "pch@fsdcorp.kr" ||
      this.username === "hair_red@naver.com" ||
      this.username === "v8395@naver.com" ||
      this.username === "k-1983@naver.com" ||
      this.username === "fid0603@naver.com" ||
      this.username === "joonyeob77@naver.com" ||
      this.username === "lbrlove@naver.com" ||
      this.username === "dogokdoobal@gmail.com" ||
      this.username === "dudrb001@gmail.com" ||
      this.username === "hjmkay@gmail.com"
    );
  }

  get isCjthemarket() {
    return (
      this.username === "dnfl1120@naver.com" ||
      this.username === "hjmkay@gmail.com"
    );
  }

  get isOliveyoungQuick() {
    return (
      this.username === "jiojio7@gmail.com" ||
      this.username === "tjgodthghk032@naver.com" ||
      this.username === "chungmin1228@naver.com" ||
      this.username === "ioooiooo1@naver.com" ||
      this.username === "rab1@naver.com" ||
      this.username === "sis5296@naver.com" ||
      this.username === "yamseng0914@naver.com" ||
      this.username === "spiri5296@hanmil.net" ||
      this.username === "son5751187@naver.com" ||
      this.username === "injlo2728@naver.com" ||
      this.username === "darkdudrb@gmail.com" ||
      this.username === "kch7371@naver.com" ||
      this.username === "thomas06180618@gmail.com" ||
      this.username === "chungmin1227@naver.com" ||
      this.username === "chungmin1229@naver.com" ||
      this.username === "smbmforever@nate.com" ||
      this.username === "rrgrr1000@gmail.com" ||
      this.username === "woejflwkd@naver.com" ||
      this.username === "a01064510270@gmail.com" ||
      this.username === "kmcompany01@naver.com" ||
      this.username === "openway@naver.com" ||
      this.username === "kmrok12@naver.com" ||
      this.username === "rlasnfl120@naver.com" ||
      this.username === "mcggg255@naver.com" ||
      this.username === "hunmincom@gmail.com" ||
      this.username === "kkukung48@gmail.com" ||
      this.username === "hyeonjun1414@naver.com" ||
      this.username === "raonhs@naver.com" ||
      this.username === "ymr109223@naver.com" ||
      this.username === "hjmkay@gmail.com"
    );
  }

  get isDeliveries() {
    return (
      this.username === "jiojio7@gmail.com" ||
      this.username === "chungmin1228@naver.com" ||
      this.username === "rab1@naver.com" ||
      this.username === "sis5296@naver.com" ||
      this.username === "yamseng0914@naver.com" ||
      this.username === "spiri5296@hanmil.net" ||
      this.username === "son5751187@naver.com" ||
      this.username === "injlo2728@naver.com" ||
      this.username === "darkdudrb@gmail.com" ||
      this.username === "kch7371@naver.com" ||
      this.username === "thomas06180618@gmail.com" ||
      this.username === "chungmin1227@naver.com" ||
      this.username === "chungmin1229@naver.com" ||
      this.username === "smbmforever@nate.com" ||
      this.username === "rrgrr1000@gmail.com" ||
      this.username === "woejflwkd@naver.com" ||
      this.username === "a01064510270@gmail.com" ||
      this.username === "kmcompany01@naver.com" ||
      this.username === "openway@naver.com" ||
      this.username === "kmrok12@naver.com" ||
      this.username === "hunmincom@gmail.com" ||
      this.username === "hyeonjun1414@naver.com" ||
      this.username === "raonhs@naver.com" ||
      this.username === "hjmkay@gmail.com"
    );
  }
}
